import React, { PropsWithChildren } from "react";
//#region  types
import { EntityNavigationCardProps } from "models/propTypes/navigationPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region  components
import { Grid } from "@mui/material";
import EntityPagination from "../drawers/entityView/entityPagination";
import StyledButton from "../buttons/styledButton";
import Icon from "../icon";
import MenuButton from "../buttons/menuButton";
//#endregion
import { CSSHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const EntityNavigationCard: React.FC<PropsWithChildren<EntityNavigationCardProps>> = (props) => {
  return (
    <Grid container className={cssExports.cardContainer}>
      <Grid
        container
        item
        className={clsx(
          cssExports.selectionPanel,
          cssExports.navigationCard,
          CSSHelper.getClassByDisplayType(props.displayType)
        )}
      >
        <Grid container item className={clsx(cssExports.selectionPanelContent)} direction="column">
          <Grid container alignContent="space-between">
            <Grid item container alignItems="flex-end" wrap="nowrap">
              <Grid item xs className={cssExports.navigationCardHeaderText}>
                {props.headerText}
              </Grid>
              <Grid item className={clsx(cssExports.navigationCardPagination)}>
                {props.total ? (
                  <EntityPagination
                    total={props.total}
                    onCurrentIndexUpdate={props.onCurrentIndexUpdate}
                    onNavigationNext={props.onNavigationNext}
                    navigationText={""}
                    initialIndex={0}
                    numPerPage={props.numPerPage}
                    displayType={props.displayType}
                  />
                ) : (
                  <></>
                )}
              </Grid>
              <Grid item>
                {props.onMenuButtonClick ? (
                  <StyledButton
                    size="xs"
                    className={clsx(cssExports.iconButton, cssExports.transparent)}
                    onClick={props.onMenuButtonClick}
                  >
                    <Icon icon={IconDefinitionConstants.WList} className={cssExports.navigationCardIcon} />
                  </StyledButton>
                ) : (
                  <MenuButton
                    menuItems={props.moreActions ?? []}
                    menuPlacement="bottom"
                    button={
                      <StyledButton size="xs" className={clsx(cssExports.iconButton, cssExports.transparent)}>
                        <Icon icon={IconDefinitionConstants.WEllipsisH} className={cssExports.navigationCardIcon} />
                      </StyledButton>
                    }
                  />
                )}
              </Grid>
            </Grid>
            {props.children}
          </Grid>
        </Grid>
      </Grid>
      <div className={cssExports.cardOverlay} onClick={props.onCardClick}></div>
    </Grid>
  );
};

export default EntityNavigationCard;
